export const environment = {
  clientId: 'drr-web.prod',
  additionalCookieDomain: false,
  configTools: false,
  description: false,
  displayVersion: true,
  optimize: true,
  log: true,
  baseURL: 'https://gatewayers.national.aaa.com',
  openAARsURL: 'https://tdr.aaa.com/tdrl/search.jsp',
  ipInterrogateURL: 'https://services.aaa.com/RESTWS/aaa/services/geo/locate',
  association: 'AAA',
  rapGoogleMapsApiKey: process.env["RAP_GOOGLE_MAPS_API_KEY"],
  googleMapsApiKey: process.env["GOOGLE_MAPS_API_KEY"],
  googleCaptchaKey: process.env["GOOGLE_RECAPTCHA_API_KEY"],
  googleCaptchaV3Key: process.env["GOOGLE_RECAPTCHA_V3_API_KEY"],
  unsecureClub: 999,
  hotjar: '2789441',
  thirdPartyCookiesUrl: 'https://dfkfmvngo6zht.cloudfront.net/v1.html',
  nativeAppView: false,
  homeBackButtonRedirectTo: '/home',
  awsLocationApiKey: process.env["AWS_LOCATION_API_KEY"]
}
